import React, { Component } from "react";
import { AUTH_TOKEN } from "../constants";
import { Link } from "react-router-dom";
import { timeDifferenceForDate, handleUnauthorized } from "../utils";
import { Mutation, Query, withApollo } from "react-apollo";
import gql from "graphql-tag";
import { LINK_QUERY } from "./LinkDetails";

const COMMENT_QUERY = gql`
  query commentQuery($id: ID!) {
    comment(id: $id) {
      id
      created
      text
      user {
        id
        name
      }
      link {
        id
      }
      replies {
        id
        text
      }
    }
  }
`;

const EDIT_COMMENT = gql`
  mutation editComment($commentId: ID!, $text: String!) {
    editComment(commentId: $commentId, text: $text) {
      id
      text
    }
  }
`;

class EditComment extends Component {
  state = {
    comment: "",
    isPosting: false,
    error: "",
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history)
  }
  componentDidMount() {
    this.props.client
      .query({
        query: COMMENT_QUERY,
        variables: { id: this.props.match.params.id },
      })
      .then(({ data }) => {
        this.setState({
          comment: data.comment.text,
        });
      });
  }

  render() {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    return (
      <Query
        query={COMMENT_QUERY}
        variables={{
          id: this.props.match.params.id,
        }}
      >
        {({ loading, error, data }) => {
          if (loading)
            return <div className="mt2 animate-flicker">Loading...</div>;
          if (error || !data.comment)
            return <div className="mt2">Could not fetch comment details.</div>;
          return (
            <div className="flex mt2 items-start">
              <div className="ml1 w-100">
                <div className="mb3">Edit comment:</div>
                <div className="f8pt lh-copy gray pt1">
                  <span>by </span>
                  {data.comment.user ? (
                    <Link
                      to={`/account/${data.comment.user.id}`}
                      className="no-underline gray link"
                    >
                      {data.comment.user.name}
                    </Link>
                  ) : (
                      "Unknown"
                    )}
                  {" | "}
                  {timeDifferenceForDate(data.comment.created)}
                </div>
                {authToken && (
                  <div className="pt3">
                    <div className="textarea-container">
                      <textarea
                        name="comment"
                        rows="6"
                        value={this.state.comment}
                        onChange={(e) =>
                          this.setState({ comment: e.target.value })
                        }
                      ></textarea>
                      <div>{!!this.state.error.length && this.state.error}</div>
                    </div>
                    <div className="pt1">
                      <Mutation
                        mutation={EDIT_COMMENT}
                        variables={{
                          commentId: data.comment.id,
                          text: this.state.comment,
                        }}
                        update={(store, { data: { editComment } }) => {
                          this.setState({
                            ...this.state,
                            comment: "",
                            isPosting: false,
                            error: "",
                          });
                          try {
                            const linkData = store.readQuery({
                              query: LINK_QUERY,
                              variables: { linkId: editComment.link.id },
                            });
                            linkData.link.comments.map((comment) => {
                              if (comment.id === this.props.match.params.id) {
                                comment.text = editComment.text;
                              }
                              return comment;
                            });
                            store.writeQuery({
                              query: LINK_QUERY,
                              data: linkData,
                              variables: { linkId: editComment.link.id },
                            });
                          } catch (err) {
                            console.log("No link query in cache to update");
                            try {
                              // Invalidate the cached feed queries
                              Object.keys(store.data.data).forEach((key) => {
                                key.match(/ROOT_QUERY.link/) &&
                                  store.data.delete(key);
                              });
                            } catch (err) {
                              console.log(
                                "No link query in cache to invalidate"
                              );
                            }
                          }
                          try {
                            // Invalidate the cached profile queries
                            Object.keys(store.data.data).forEach((key) => {
                              key.match(/ROOT_QUERY.userComments/) &&
                                store.data.delete(key);
                            });
                          } catch (err) {
                            console.log(
                              "No profile query in cache to invalidate"
                            );
                          }
                        }}
                        onError={(err) => {
                          this.checkUnauthorized(err)
                          if (err.graphQLErrors && err.graphQLErrors.length) {
                            this.setState({
                              error: data.graphQLErrors[0],
                              isPosting: false,
                            });
                          } else {
                            this.setState({
                              error:
                                "An error occured when modifying the comment",
                              isPosting: false,
                            });
                          }
                        }}
                        onCompleted={() => this.props.history.goBack()}
                      >
                        {(postComment) => (
                          <button
                            className="pointer button"
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                isPosting: true,
                              });
                              postComment();
                            }}
                            disabled={this.state.isPosting}
                          >
                            {this.state.isPosting ? "saving" : "update"}
                          </button>
                        )}
                      </Mutation>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(EditComment);



// WEBPACK FOOTER //
// ./src/components/EditComment.js